import { TextField } from "@material-ui/core";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
const useStyles = makeThemedStyles("TextInput", (theme) => ({
  root: {
    "& input": {
      border: "1px solid gray",
      padding: "10px",
      borderRadius: "10px",
      width: "100%",
      background: "white",
    },
  },
}));
/*
height: 2em; width: 2em; margin-right: 1.065em; margin-left: 0.66em; background: rgb(0, 169, 163); -webkit-mask: url("http://localhost:4000/http://localhost:4000/api/files/?file=/icons/navitems/corporate.svg") center center / contain no-repeat;
*/
const TextInput = (
  props: React.PropsWithChildren<{
    type?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    errors?: string[];
    value?: string;
    onChange?: (value: string) => void;
  }>
) => {
  const classes = useStyles();
  return (
    <TextField
      className={classes.root}
      type="text"
      fullWidth={props.fullWidth}
      disabled={props.disabled}
      error={props.errors && props.errors.length > 0}
      helperText={(props.errors || []).join(", ")}
      value={props.value}
      onChange={(e) => {
        if (props.onChange) props.onChange(e.target.value);
      }}
      InputProps={
        {
          disableUnderline: true,
          type: props.type,
          style: {
            fontSize: "16px",
            color: "rgba(76, 81, 87, 1)",
          },
        } as any
      }
    />
  );
};

export default TextInput;

/*
      <div className={classes.calculateHeading}>
        {!subKpisExist ? t('Actual') : t('Calculated Kpi Value')}
      </div>
      <div className={classes.calculateContent}>
        <TextField
          type="number"
          disabled={!allowedActions.editValues || subKpisExist}
          value={actual}
          onChange={e => setActual(e.target.value)}
          InputProps={
            {
              disableUnderline: true,
              type: 'number',
              style: {
                fontSize: '16px',
                color: 'rgba(76, 81, 87, 1)'
              }
            } as any
          }
        />
      </div>

*/
